import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Typography, Stack, CircularProgress } from '@esgian/esgianui';
import { ProfileLink } from '@components/Links';
import moment from 'moment';
import { useTimezone } from '@hooks/useTimezone';

const FutureScheduleTab = ({ futurePortCallsQuery }) => {
  const { getTimeZoneDateDisplay } = useTimezone();
  const { data: futurePortCalls = [], isFetching: loading } = futurePortCallsQuery || {};

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={4}>
        <CircularProgress size={24} />
        <Typography variant="body2" sx={{ ml: 2 }}>
          Loading future schedule...
        </Typography>
      </Box>
    );
  }

  if (!futurePortCalls.length) {
    return (
      <Paper sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No future port calls scheduled
        </Typography>
      </Paper>
    );
  }

  return (
    <Stack spacing={2}>
      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
        Upcoming Port Calls
      </Typography>

      {futurePortCalls.slice(0, 5).map((call, index) => (
        <Paper key={index} sx={{ p: 2 }}>
          <Stack spacing={1}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <ProfileLink
                profile="port"
                name={call.portName}
                id={call.portId}
                linkVariant="body1"
                sx={{ fontWeight: 'bold' }}
              />
              <Typography variant="caption" color="text.secondary">
                {call.imo}
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between">
              <Box>
                <Typography variant="caption" color="text.secondary">
                  Arrival
                </Typography>
                <Typography variant="body2">
                  {call.arriving && moment(call.arriving).isValid()
                    ? getTimeZoneDateDisplay(call.arriving)
                    : '-'}
                </Typography>
              </Box>

              <Box>
                <Typography variant="caption" color="text.secondary">
                  Departure
                </Typography>
                <Typography variant="body2">
                  {call.departing && moment(call.departing).isValid()
                    ? getTimeZoneDateDisplay(call.departing)
                    : '-'}
                </Typography>
              </Box>
            </Box>

            {call.lastUpdated && (
              <Typography variant="caption" color="text.secondary">
                Last updated:{' '}
                {moment(call.lastUpdated).isValid()
                  ? getTimeZoneDateDisplay(call.lastUpdated)
                  : '-'}
              </Typography>
            )}
          </Stack>
        </Paper>
      ))}

      {futurePortCalls.length > 5 && (
        <Typography variant="caption" color="text.secondary" textAlign="center">
          Showing first 5 of {futurePortCalls.length} scheduled port calls
        </Typography>
      )}
    </Stack>
  );
};

FutureScheduleTab.propTypes = {
  futurePortCallsQuery: PropTypes.object
};

export default FutureScheduleTab;
